// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.tile-border[data-v-89e8a4ae] {\n  border-radius: 20px !important;\n}\n.custom-panel-heading[data-v-89e8a4ae] {\n  border-radius: 20px 20px 0 0 !important;\n  background-color:#495057 !important;\n}\n.release-notes-content[data-v-89e8a4ae] {\n  height: 300px; /* same with dashboard-jobs-chart height*/\n  overflow-y: scroll;\n}\n", ""]);
// Exports
module.exports = exports;
